const minLength = 1;
const maxLength = 8;

// 假设用户名前缀
const prefix = '';

// 生成随机用户名的函数
function generateRandomUsername(prefix, minLength, maxLength) {
  const possibleCharacters = 'abcdefghijklmnopqrstuvwxyz'; // 可用的字符集
  const charCount = maxLength - minLength + 1; // 字符数量
  const charIndexes = new Array(charCount).fill(null).map(() => possibleCharacters.charCodeAt(Math.floor(Math.random() * possibleCharacters.length)));
  const username = prefix + String.fromCharCode(...charIndexes).substring(0, maxLength);
  return username;
}

// 检查用户名是否存在的函数（示例中简单返回true或false）
function checkUsernameExists(username) {
  // 假设我们通过某种方式检查用户名是否存在
  return Math.random() >= 0.5; // 50%的概率用户名不存在
}

// 循环生成不重复的用户名

function generateUserName(){
  let username;
  do {
    username = generateRandomUsername(prefix, minLength, maxLength);
  } while (!checkUsernameExists(username));
  console.log('username：' + username);
  return username
}


/*******
 * @description: 病案质控
 * @param {*} webData -
 * @param {*} extraParams -
 * @return {*}
 */
// export function bazk(webData, extraParams = {}) {
//   return "userCode=-2&singleCode=frameIndex&loginKey=userID&compNo=CF148";
// }

export default {
  generateUserName
}
